// @flow
import { CategoryExperiencesActionTypes } from './constants';

type CategoryExperiencesAction = { type: string, payload: {} | string };

// common success
export const categoryExperiencesApiResponseSuccess = (actionType: string, data: any): CategoryExperiencesAction => ({
    type: CategoryExperiencesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const categoryExperiencesApiResponseError = (actionType: string, error: string): CategoryExperiencesAction => ({
    type: CategoryExperiencesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getCategoryExperience = (id: string): CategoryExperiencesAction => ({
    type: CategoryExperiencesActionTypes.GET_CATEGORY_EXPERIENCE,
    payload: { id },
});

export const addCategoryExperience = (categoryExperience:any):CategoryExperiencesAction=>({
    type:CategoryExperiencesActionTypes.ADD_CATEGORY_EXPERIENCE,
    payload:categoryExperience
})
export const updateCategoryExperience = (categoryExperience:any):CategoryExperiencesAction=>({
    type:CategoryExperiencesActionTypes.UPDATE_CATEGORY_EXPERIENCE,
    payload:categoryExperience
})
export const deleteCategoryExperience = (id:string):CategoryExperiencesAction=>({
    type:CategoryExperiencesActionTypes.DELETE_CATEGORY_EXPERIENCE,
    payload:{id}
})

export const listCategoryExperiences = (params:any): CategoryExperiencesAction => ({
    type: CategoryExperiencesActionTypes.LIST_CATEGORIES_EXPERIENCE,
    payload: params,
});


export const resetCategoriesExperience = (): CategoryExperiencesAction => ({
    type: CategoryExperiencesActionTypes.RESET,
    payload: {},
});

